export enum CreditTypeEnum {
  COLATERAL_FREE = "1",
  PLEDGE_AUTO = "2",
  PLEDGE_REAL_ESTATE = "3",
  NEW_AUTO = "4",
  USED_AUTO = "5",
}

export enum PledgeTypeEnum {
  REAL_ESTATE = "1",
  AUTO = "2",
  MOVING_PROPERTY = "3",
  RENTED_PREMISES = "4",
  NOTHING = "5",
}

export interface IApplicationFormStep1 {
  phone: string;
  agreement: boolean;
}

export interface IApplicationFormStep1Code {
  verification_code: string;
}

export interface IApplicationFormStep2 {
  name: string;
  last_name: string;
  middle_name: string;
  iin: string;
  city: string;
}

export interface IApplicationFormStep3 {
  credit_type: string;
  credit_sum: string;
  credit_period: string;
  credit_monthly_payment: string;
  credit_target: string;
  credit_car_brand: string;
  credit_car_name: string;
  credit_car_type: string;
  credit_car_year: string;
  credit_car_doc_number: string;
  credit_car_price: string;
  advance_payment: string;
}

export interface IApplicationFormStep4 {
  company_name: string;
  classification: string;
  position: string;
  working_period: string;
  month_income: string;
}

export interface IApplicationFormStep5 {
  pledge_type: string;
  real_estate_price: string;
  real_estate_address_state: string;
  real_estate_address_district: string;
  real_estate_address_village: string;
  real_estate_full_address: string;
  collateral_car_brand: string;
  collateral_car_name: string;
  collateral_car_type: string;
  collateral_car_year: string;
  collateral_car_doc_number: string;
  collateral_car_price: string;
}

export interface IApplicationForm
  extends IApplicationFormStep1,
    IApplicationFormStep1Code,
    IApplicationFormStep2,
    IApplicationFormStep3,
    IApplicationFormStep4,
    IApplicationFormStep5 {}

export interface INewCarFields {
  brand_name?: string;
  type_name?: string;
  model_name?: string;
  price_of_car?: string;
}

export interface IUsedCarFields extends INewCarFields {
  production_year?: string;
  technical_passport?: string;
}
export interface IRealEstateFields {
  price_of_real_estate?: string;
  state?: string;
  district?: string;
  village?: string;
  detail_address?: string;
  type_of_collateral?: string;
}

export interface ILoanFields extends IUsedCarFields {
  credit_sum: string;
  credit_period_id: string;
  credit_monthly_payment: string;
  credit_target_id: string;
  advance_payment?: string;
}

export interface IPersonalFields {
  phone: string;
  name: string;
  last_name: string;
  middle_name: string;
  iin: string;
  city_id: string;
}

export interface IJobFields {
  company_name: string;
  classification_id: string;
  position: string;
  working_period: string;
  month_income: string;
}

export interface ICollateralFields extends IUsedCarFields, IRealEstateFields {}

export interface IApplicationDataStep1 {
  verification_code: string;
  product_id: string;
  loan: ILoanFields;
  personal: IPersonalFields;
}

export interface IApplicationDataStep2 extends IApplicationDataStep1 {
  job: IJobFields;
}

export interface IApplicationDataFinalStep extends IApplicationDataStep2 {
  collateral: ICollateralFields;
}
